(() => {
  if (window.sfCampaignCarousels || !window.EmblaCarousel || !window.sfSlider) return;
  window.sfCampaignCarousels = true;
  const init = root => {
    if (root.sfSlider) return;
    const viewport = root.querySelector('.sf-campaign-hero__slides');
    const container = viewport?.querySelector('.sf-campaign-hero__container');
    const slides = [...root.querySelectorAll('[data-campaign-slide]')];
    if (!container || slides.length < 2) return;
    const mobile = matchMedia('(max-width: 1024px)');
    let current = 0, layoutWidth = 0, layoutHeight = innerHeight;
    root.dataset.campaignReady = 'true';
    const setHeight = () => {
      if (mobile.matches) {
        // Do not resize the image on Safari's toolbar changes during a vertical pan.
        if (layoutWidth !== viewport.clientWidth) { layoutWidth = viewport.clientWidth; layoutHeight = innerHeight; }
        const header = document.querySelector('[data-site-header]')?.offsetHeight || 0;
        const controls = root.querySelector('[data-slider-controls]')?.offsetHeight || 0;
        const copy = Math.max(...slides.map(slide => {
          const node = slide.querySelector('.sf-campaign-slide__copy');
          return node ? node.offsetHeight - parseFloat(getComputedStyle(node).paddingTop) : 0;
        }));
        const available = layoutHeight - header - copy - controls - 24;
        const preferred = Math.min(300, viewport.clientWidth * .78, layoutHeight * .34);
        root.style.setProperty('--sf-hero-mobile-image-height', Math.floor(Math.min(preferred, Math.max(120, available))) + 'px');
        viewport.style.height = slides[current].offsetHeight + 'px';
      } else { layoutWidth = 0; root.style.removeProperty('--sf-hero-mobile-image-height'); viewport.style.height = ''; }
    };
    const plugins = window.EmblaCarouselWheelGestures ? [window.EmblaCarouselWheelGestures()] : [];
    const carousel = window.EmblaCarousel(viewport, { container, slides, align: 'start', loop: false, skipSnaps: false, inViewThreshold: .5, duration: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 25 }, plugins);
    const slider = window.sfSlider(root, carousel, {
      viewport, slides, onResize: setHeight,
      onSettle(index) {
        current = index; root.dataset.activeSlide = String(index + 1);
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        setHeight();
      }
    });
    root.campaignSelect = index => slider.selectSlide(index);
    root.campaignDeselect = () => slider.deselect();
    root.campaignDestroy = () => { slider.destroy(); delete root.dataset.campaignReady; };
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-campaign-carousel]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-campaign-carousel]').forEach(root => root.campaignDestroy?.()));
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-campaign-slide]'), root = slide?.closest('[data-campaign-carousel]');
    root?.campaignSelect?.([...root.querySelectorAll('[data-campaign-slide]')].indexOf(slide));
  });
  document.addEventListener('shopify:block:deselect', event => event.target.closest('[data-campaign-carousel]')?.campaignDeselect?.());
})();
